var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-content filter-field" },
    [
      !_vm.custom
        ? _c(
            "el-select",
            _vm._b(
              {
                attrs: {
                  clearable: _vm.clearable,
                  filterable: true,
                  placeholder: _vm.$attrs.placeholder || "请选择"
                },
                on: { change: _vm.selectChange },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              },
              "el-select",
              _vm.$attrs,
              false
            ),
            _vm._l(_vm.options, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: {
                  label: item[_vm.props.label],
                  value: item[_vm.props.value]
                }
              })
            }),
            1
          )
        : _vm._t("select")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1279210c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1279210c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/select.vue
// module id = null
// module chunks = 